export enum SCEventName {
  ItemAdded = 'item:added',
  ItemDeleted = 'item:deleted',
  ItemSaved = 'item:saved',
  PublishComplete = 'publish:complete',
}

export type SCWebHookItem = {
  Id: string;
  Language: string;
};

export type SCPublisherOptions = {
  CompareRevisions: boolean;
  Deep: boolean;
  Mode: string;
  RepublishAll: boolean;
  RootItemId: string;
  LanguageName: string;
};

export type PublishCompletePayload = {
  EventName: SCEventName.PublishComplete;
  'DistributedPublishOptions[]': SCPublisherOptions[];
};

export type SCWebhookPayload =
  | {
      EventName: SCEventName.ItemAdded;
      Item: SCWebHookItem;
    }
  | {
      EventName: SCEventName.ItemDeleted;
      Item: SCWebHookItem;
    }
  | {
      EventName: SCEventName.ItemSaved;
      Item: SCWebHookItem;
    }
  | PublishCompletePayload;
